define("settings/routes/users/new", ["exports", "ember-concurrency/async-arrow-runtime", "@ember/routing/route", "@ember/service", "ember-concurrency", "later/utils/time-format"], function (_exports, _asyncArrowRuntime, _route, _service, _emberConcurrency, _timeFormat) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"@ember/routing/route",0,"@ember/service",0,"ember-concurrency",0,"later/utils/time-format"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  let NewRoute = _exports.default = (_class = class NewRoute extends _route.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "alerts", _descriptor, this);
      _initializerDefineProperty(this, "auth", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "router", _descriptor4, this);
      _initializerDefineProperty(this, "segment", _descriptor5, this);
      _initializerDefineProperty(this, "settings", _descriptor6, this);
      _initializerDefineProperty(this, "store", _descriptor7, this);
      _defineProperty(this, "handleSubmit", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function (_ref) {
          var _this = this;
          let {
            email,
            name
          } = _ref;
          return function* () {
            try {
              const userInvite = _this.currentAccount.invite({
                email,
                name
              });
              const {
                alert,
                response
              } = yield _this.settings.submitForm.perform(userInvite, 'account.users.new', {
                email
              });

              // Deletes unsaved user record
              _this.store.peekAll('user').findBy('id', null).unloadRecord();
              _this.alerts.add(alert);
              _this.segment.track('added-team-member', {
                team_member_id: response.id,
                team_member_email: response.email
              });
              _this.send('handleUpdate'); // Refreshes the parent route to display the new user
              _this.router.transitionTo('account.users');
            } catch ({
              alert
            }) {
              alert.message = _this.intl.t('account.users.new.error.message', {
                email
              });
              alert.timeout = 5000;
              _this.alerts.add(alert);
            }
          }();
        }
      }), null, "handleSubmit", null));
      _defineProperty(this, "handleClose", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (user) {
          const condition = user.isNew && (user.email || user.name) || !user.isNew && user.hasDirtyAttributes;
          yield this.settings.confirmClose(condition);
          user.rollbackAttributes();
          this.router.transitionTo('account.users');
        }
      }), null, "handleClose", null));
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    model() {
      return this.store.createRecord('user', {
        account: this.currentAccount,
        createdTime: (0, _timeFormat.timestamp)()
      });
    }
    redirect() {
      if (!this.auth.currentUserModel?.canAddUser) {
        this.router.transitionTo('account.users');
      }
    }
    setupController(controller, model) {
      const {
        users
      } = this.modelFor('users');
      const userCount = users.length;
      const totalUsers = this.currentAccount.totalUsers ?? 1;
      let availableSeats = totalUsers - userCount;
      availableSeats = availableSeats > 0 ? availableSeats : 0;
      controller.setProperties({
        user: model,
        handleSubmit: this.handleSubmit,
        handleClose: this.handleClose,
        availableSeats,
        isAdmin: this.auth.currentUserModel?.admin
      });
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "store", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class);
});